import {createSlice} from '@reduxjs/toolkit'

export const statisticsSlice = createSlice({
  name: 'statistics',
  initialState: {
    listRecentUsers: [],
    listUsersWithoutReq: [],
    listRecentUsersAdmin: [],
    listGetReportsMostUsed: [],
  },
  reducers: {
    getRecentUsers: (state, action) => {
      state.listRecentUsers = action.payload
    },
    getUsersWithoutReq: (state, action) => {
      state.listUsersWithoutReq = action.payload
    },
    getAdminActive: (state, action) => {
      state.listRecentUsersAdmin = action.payload
    },
    getReportsMostUsed: (state, action) => {
      state.listGetReportsMostUsed = action.payload
    },
  },
})

export const {getRecentUsers, getUsersWithoutReq, getAdminActive, getReportsMostUsed} =
  statisticsSlice.actions
export default statisticsSlice.reducer
